(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NodeConnected", [], factory);
	else if(typeof exports === 'object')
		exports["NodeConnected"] = factory();
	else
		root["NodeConnected"] = factory();
})(this, function() {
return 